module.exports = __webpack_public_path__ + "img/ic-message.90315b3a.svg";